export const STATISTICS_DATA_REQUEST = 'STATISTICS_DATA_REQUEST';
export const STATISTICS_DATA_SUCCESS = 'STATISTICS_DATA_SUCCESS';
export const STATISTICS_DATA_FAILURE = 'STATISTICS_DATA_FAILURE';
export const HOST_POWER_STATUS_REQUEST = 'HOST_POWER_STATUS_REQUEST';
export const HOST_POWER_STATUS_SUCCESS = 'HOST_POWER_STATUS_SUCCESS';
export const HOST_POWER_STATUS_FAILURE = 'HOST_POWER_STATUS_FAILURE';
export const TOASTS_ADD = 'TOASTS_ADD';
export const TOASTS_CLEAR = 'TOASTS_CLEAR';
export const TOASTS_DELETE = 'TOASTS_DELETE';
export const STORAGE_VMWARE_INIT = 'STORAGE_VMWARE_INIT';
export const STORAGE_VMWARE_ADD_CONTROLLER = 'STORAGE_VMWARE_ADD_CONTROLLER';
export const STORAGE_VMWARE_ADD_DISK = 'STORAGE_VMWARE_ADD_DISK';
export const STORAGE_VMWARE_REMOVE_CONTROLLER = 'STORAGE_VMWARE_REMOVE_CONTROLLER';
export const STORAGE_VMWARE_UPDATE_CONTROLLER = 'STORAGE_VMWARE_UPDATE_CONTROLLER';
export const STORAGE_VMWARE_REMOVE_DISK = 'STORAGE_VMWARE_REMOVE_DISK';
export const STORAGE_VMWARE_UPDATE_DISK = 'STORAGE_VMWARE_UPDATE_DISK';
export const NOTIFICATIONS_GET_NOTIFICATIONS = 'NOTIFICATIONS_GET_NOTIFICATIONS';
export const NOTIFICATIONS_TOGGLE_DRAWER = 'NOTIFICATIONS_TOGGLE_DRAWER';
export const NOTIFICATIONS_SET_EXPANDED_GROUP = 'NOTIFICATIONS_SET_EXPANDED_GROUP';
export const NOTIFICATIONS_MARK_AS_READ = 'NOTIFICATIONS_MARK_AS_READ';
export const NOTIFICATIONS_MARK_GROUP_AS_READ = 'NOTIFICATIONS_MARK_GROUP_AS_READ';
export const NOTIFICATIONS_MARK_AS_CLEAR = 'NOTIFICATIONS_MARK_AS_CLEAR';
export const NOTIFICATIONS_MARK_GROUP_AS_CLEARED = 'NOTIFICATIONS_MARK_GROUP_AS_CLEARED';
export const NOTIFICATIONS_POLLING_STARTED = 'NOTIFICATIONS_POLLING_STARTED';
export const BOOKMARKS_REQUEST = 'BOOKMARKS_REQUEST';
export const BOOKMARKS_SUCCESS = 'BOOKMARKS_SUCCESS';
export const BOOKMARKS_FAILURE = 'BOOKMARKS_FAILURE';
export const BOOKMARKS_MODAL_OPENED = 'BOOKMARKS_MODAL_OPENED';
export const BOOKMARKS_MODAL_CLOSED = 'BOOKMARKS_MODAL_CLOSED';
export const BOOKMARK_FORM_SUBMITTED = 'BOOKMARK_FORM_SUBMITTED';
export const PASSWORD_STRENGTH_PASSWORD_CHANGED = 'PASSWORD_STRENGTH_PASSWORD_CHANGED';
export const PASSWORD_STRENGTH_PASSWROD_MATCHED = 'PASSWORD_STRENGTH_PASSWROD_MATCHED';
export const FACT_CHART_DATA_REQUEST = 'FACT_CHART_DATA_REQUEST';
export const FACT_CHART_DATA_SUCCESS = 'FACT_CHART_DATA_SUCCESS';
export const FACT_CHART_DATA_FAILURE = 'FACT_CHART_DATA_FAILURE';
export const OPEN_FACT_CHART_MODAL = 'OPEN_FACT_CHART_MODAL';
export const CLOSE_FACT_CHART_MODAL = 'CLOSE_FACT_CHART_MODAL';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/consts.js